import { API_URL } from "../config/api";

async function parseJson(res) {
  return res.json().catch(() => ({}));
}

async function request(path, options = {}) {
  const res = await fetch(`${API_URL}${path}`, {
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  const json = await parseJson(res);
  if (!res.ok) {
    throw new Error(json.message || `Erreur HTTP ${res.status}`);
  }
  return json;
}

/** Liste légère (sans contenu intégral ; contentBytes pour pastille taille). */
export async function fetchNotesList() {
  const json = await request("/notes");
  return Array.isArray(json.items) ? json.items : [];
}

export async function fetchNote(noteId) {
  if (!noteId) return null;
  return request(`/notes/${encodeURIComponent(noteId)}`);
}

export async function createNote(payload = {}) {
  return request("/notes", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateNote(noteId, payload) {
  return request(`/notes/${encodeURIComponent(noteId)}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export async function deleteNote(noteId) {
  return request(`/notes/${encodeURIComponent(noteId)}`, {
    method: "DELETE",
  });
}
